// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__15NIo","alert":"SettungsInbox_alert__2S9ku"};